const H1 = {
  color: 'heading',
  fontFamily: 'heading',
  fontSize: [6, 7],
  fontWeight: 1,
  lineHeight: 0,
};

const H2 = {
  ...H1,
  fontSize: [5, 6],
  lineHeight: [2, 1],
  my: 6,
};

const H3 = {
  ...H1,
  fontSize: [4, 5],
  lineHeight: 2,
};

const H4 = {
  ...H1,
  fontSize: [3, 4],
  lineHeight: 2,
};

const H4Disabled = {
  ...H1,
  fontSize: [3, 4],
  lineHeight: 2,
  color: 'second.0',
};

const H5 = {
  ...H1,
  fontSize: [2, 3],
  lineHeight: 2,
};

const H6 = {
  ...H1,
  fontSize: [1, 2],
  lineHeight: 2,
};

const headingVariants = { H1, H2, H3, H4, H4Disabled, H5, H6 };

export default headingVariants;
